import { render, staticRenderFns } from "./DocumentStep.vue?vue&type=template&id=1b4d80e6&"
import script from "./DocumentStep.vue?vue&type=script&lang=js&"
export * from "./DocumentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports